<script setup lang="ts">
// #719 観点B: モバイルナビ背景に敷く交易所のマップ画像。
import emporiumMapBg from '@/assets/images/map/AreaMap_Emporium.webp'

const runtimeConfig = useRuntimeConfig()

const { isMobile } = useIsMobile()

useSeoMeta({
  title: '老匠のよろず屋 | Code & Magic',
  description: 'エンコーディアに隠れた魔導書探しを依頼することもできる。',
  ogTitle: '老匠のよろず屋 | Code & Magic',
  ogDescription: 'エンコーディアに隠れた魔導書探しを依頼することもできる。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  middleware: ['authenticated', 'confirm-game-state'],
  layout: false,
  usePageReady: true,
})

const { finishLoading } = usePageReady()

onMounted(async () => {
  await finishLoading()
})
</script>

<template>
  <NuxtLayout :name="isMobile ? 'mobile-nav' : 'centering43'">
    <SceneMap
      scene-id="cmp_emporium"
      back-to-text="冒険者のキャンプに戻る"
      :mobile="isMobile"
      :mobile-background="emporiumMapBg"
    >
      <template #map>
        <div class="pa-0 ma-0 fill-height w-100">
          <v-img
            src="@/assets/images/map/AreaMap_Emporium.webp"
            width="100%"
            lazy-src="@/assets/images/map/LazyAreaMap_Emporium.png"
            :transition="false"
            cover
            class="content-image"
          >
            <EmporiumProductShelf class="content-overlay" />
          </v-img>
        </div>
      </template>

      <!-- #719 観点B: モバイルは ProductShelf が内部で isMobile 分岐しリスト表示。
           購入/ギフトキーのロジックは ProductShelf に集約したまま。 -->
      <template #mobile>
        <EmporiumProductShelf />
      </template>
    </SceneMap>
  </NuxtLayout>
</template>

<style scoped>
.content-image {
  height: 100%;
}

.content-overlay {
  position: absolute;
  top: 8%;
  left: 0;
  width: 100%;
  bottom: 10%;

  z-index: 2;

  opacity: 0.9;
}
</style>
